import React,{ useEffect } from 'react';
import	{useNavigate} from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import HeaderBack from '././HeaderBack';
import Nav from './Navigation';
import PostAction from './PostAction';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import UploadImg from './UploadImg';

export default function Post({titleHead}){
	let navigate = useNavigate();
	useEffect(() => {
		let authToken = sessionStorage.getItem("Auth Token");
		
		if(authToken){
			navigate('/post')
		}
		
		if(!authToken){
			navigate('/')
		}
	}, [])
	
	const Mon = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	
	
	const date = new Date();
	const [month, day, year] = [Mon[date.getMonth()], date.getDay(), date.getFullYear()];
	const [hour, minutes] = [date.getHours(), date.getMinutes()]
	
	return(
		<>
		<main>
			<HeaderBack titleHead={titleHead}/>
				
				<section className="post">
					<div className="post-user-info">
						<Avatar alt="Remy Sharp" src="https://source.unsplash.com/random/girl" onClick={() => {navigate('/profile')}} sx={{ width: 50, height: 50 }} />
						<div className="post-user-id">
							<h3>Infi</h3>
							<h5>@infi</h5>
						</div>
					</div>
					<p>The end and the beginning is one thing ^^, Scary right?</p>
					
					<img alt="post img" src="https://source.unsplash.com/random/girl" />
					
					<h5 className="time">{hour}:{minutes} . {month} {day}, {year}</h5>	
				</section>
				
				<hr />
				<PostAction />
				
				<article className="create-post">
					<Avatar alt="Remy Sharp" src="https://source.unsplash.com/random/girl" sx={{ width: 50, height: 50 }} />
					<TextareaAutosize
					aria-label="minimum height"
					minRows={4}
					placeholder="Meow Your Reply"
					style={{ width: '100%', padding: 15, border: "none", color: "#ec407a" }}
					/>
				</article>
				<hr style={{ color: '#ab47bc' }} />

				<UploadImg />

		</main>
		<Nav />
		</>
	);
}